//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getMyRank} from '@/api/vip';
import global_ from '../../components/Global'
export default {
  data() {
    return {
      typeList:[],
      userInfo:{},
      scoreRuleList:[],
      rate:0,
      isMaxed:false,
      dayNum:0,
      userId:''
    };
  },
  methods: {
    get_my_rank(){
      let params = {userId:this.userId}
      getMyRank(params).then((res) => {
            this.typeList = res.data.types;
            this.userInfo = res.data.data;
            this.scoreRuleList = res.data.scoreRule;
            this.dayNum = res.data.curScore;
            this.getRate(this.userInfo.curScore,this.userInfo.nextScore);
      })
    },
    toPath(type){
      if(type == 0){//今日积分
        this.$router.push({path: '/vip/score_detail',query:{userId:this.userId}})
      }else{ //等级介绍
        this.$router.push({path: '/vip/rank_recommend'})
      }
    },
    getRate(curScore_int,nextScore_int){
      this.rate = 0;
      if(curScore_int > 0 && curScore_int == nextScore_int){
        this.rate = 100;
      }else if(curScore_int > 0 && curScore_int != nextScore_int){
        this.rate = (curScore_int/nextScore_int)*100;
      }else if(curScore_int >0 && nextScore_int ==0){
        this.rate = 101;
      }else{
        this.rate = 0;
      }

      if(this.rate > 100){
          this.rate = 100;
          this.isMaxed = true;
      }else {
          this.isMaxed = false;
      }
    }
  },
  mounted () {
    this.userId = this.$route.query.userId;
    this.get_my_rank();
  }
};



// WEBPACK FOOTER //
// ./src/pages/vip/my_rank.vue